export default function(params) {
  var self = this;

  self.data = ko.mapping.fromJS(params);
  self.data.fresh = ko.computed({
    read: function () {
      return !self.data.is_seen();
    },
    write: function (value) {
      self.data.is_seen(!value);
    }
  });

  self._destroy = ko.observable(false);
  self.recentlyUpdated = ko.observable(!self.data.fresh());

  self.UUID = ko.computed(function() {
    return Kadenze.Util.UUID(300);
  });

  // Class when the item is marked as viewed
  self.viewedClass = ko.computed(function() {
    return self.data.is_read() ? 'notification notification--read' : 'notification';
  });

  // Url for when the item is clicked
  self.targetUrl = ko.computed(function() {
    return Kadenze.Routes.messenger_conversation_with_id_path(self.data.id());
  });


  // Returns if the item is in view or not
  self.isInView = function() {
    var $node = $('#' + self.UUID()),
      $parentObject = $node.parents('.notification-center__content');

    return ($parentObject.scrollTop() + $parentObject.height()) > ($node.offset().top + 20);
  };

  // when the item is clicked window.location is sent to its' target
  self.navigateToTarget = function() {
    window.location.href = self.targetUrl();
  };

  self.computedSubject = ko.computed(function() {
    var subject;
    if (self.data.subject() != '-') {
      subject = self.data.subject();
    } else if (self.data.participants().length > 3) {
      subject = _.map(self.data.participants(), function (participant) {
        return participant.first_name();
      });
      subject = subject.join(', ');
    } else {
      subject = _.map(self.data.participants(), function (participant) {
        return participant.full_name();
      });
      subject = subject.join(', ');
    }
    return subject;
  });

  self.isRecent = ko.computed(function () {
    return moment().diff(moment(self.data.updated_at()), 'days') <= 7;
  });

  return self;
}

